export default __webpack_public_path__ + "static/media/mobile.313bed4a.svg";